/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Modal,
  Form,
  Input,
  Row,
  Col,
  Typography,
  notification,
  DatePicker,
  Select,
  Radio,
  Divider,
} from 'antd';
import { FilterFilled, SettingOutlined } from '@ant-design/icons';
import { Button as CrceButton, Checkbox as CrceCheckbox } from '@crc-evans/ui-components';
import { FileBarChart, Thermometer, Eye, X } from 'lucide-react';
import moment from 'moment';
import { any } from 'prop-types';
import { OnFetchWeldTestDetails, OnGeneratePQtReports } from '../../redux/PQTlogDetails/saga';
import ProjectHeatProfileList from './ProjectHeatProfileList_styled';
import ProjectHeatProfile from './ProjectHeatProfile';
import MaterialsWeatherInspectionModal from './MaterialsWeatherInspectionModal';
import axiosConfig from '../../redux/PQTlogDetails/axiosConfig1';
import { getPopupContainerBody } from '../ShippingManagement/shipmentFieldOptions';
import '../DSR/DownTimeModal.css';
import '../../pages/dashboard/DashboardPage.css';
import '../GenerateReport.css';
// import { delay } from 'lodash';

const { Title, Text } = Typography;
const { Option } = Select;
const DATE_DROPDOWN = 'modern-dropdown-popup mc-dpr-datepicker-dropdown';
const SELECT_DROPDOWN = 'modern-dropdown-popup mc-dpr-modal-select-dd';

const parseProjectMaterialByProject = (res) => {
  const rows = res?.data?.data;
  return Array.isArray(rows) ? rows : [];
};

const getSelectedMaterialCertificateUrls = (rows, selectedKeys) => {
  if (!Array.isArray(rows) || !Array.isArray(selectedKeys) || selectedKeys.length === 0) {
    return [];
  }
  const keySet = new Set(selectedKeys.map((key) => String(key)));
  return rows
    .filter((row) => keySet.has(String(row?.id)))
    .map((row) => row?.certificate?.fileURL)
    .filter((url) => url != null && String(url).trim() !== '');
};

const hasMaterialCertificate = (record) =>
  record?.certificate != null && JSON.stringify(record.certificate) !== '{}';

const formatCertificateOptionLabel = (item) => {
  const parts = [
    item?.name,
    item?.batchNumber != null && item?.batchNumber !== '' ? `Batch ${item.batchNumber}` : null,
    item?.productCode,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(' — ') : `Material ${item?.id}`;
};
var obj = {
  fromDate: '22-03-2022',
  toDate: '22-03-2023',
  sowId: 1,
  format: 'CSV',
  email: '',
  generatedBy: '',
  projectId: 1,
  generateReport: false,
};
const GenerateReport = (props) => {
  const {
    isReportModalVisible,
    setIsReportModalVisible,
    setLocationData,
    locationData,
    projectIdValue,
    onGenerateReport,
    isLogReportsLoading,
    isWriteAccess,
    selectedSOW,
    selectedProject,
    pipelineList,
    setFileURL,
    /** Optional hook when user opens materials / weather / inspection (e.g. analytics). */
    onViewDetails,
    /** `{ fromDate, toDate }` from PQT Results calendar — materials / weather / inspection API */
    logDateRange,
    /** After successful PQT weld recalculate, bump key so `LogCalender` refetches inspection report rows */
    onAfterRecalculateSuccess,
  } = props;

  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  const [pipeline, setPipeline] = useState([]);
  const [format, setFormat] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loadingReport, setLoadingReport] = useState(false);
  const [loadingWeldIds, setLoadingWeldIds] = useState(false);
  const [weldTestList, setWeldTestList] = useState([]);

  // Heat Profile state variables
  const [isHeatProfileModalVisible, setIsHeatProfileModalVisible] = useState(false);
  const [showHeatProfileForm, setShowHeatProfileForm] = useState(false);
  const [editingHeatProfile, setEditingHeatProfile] = useState(null);

  // New state variables for Project-Based Heat Profile
  const [includeHeatProfile, setIncludeHeatProfile] = useState(false);
  const [selectedHeatProfileIds, setSelectedHeatProfileIds] = useState([]);
  const [heatProfileList, setHeatProfileList] = useState([]);
  const [loadingHeatProfiles, setLoadingHeatProfiles] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [generatedReportUrl, setGeneratedReportUrl] = useState(null);
  const [pqtWeldRecalculateLoading, setPqtWeldRecalculateLoading] = useState(false);
  const [isRecalculateModalVisible, setIsRecalculateModalVisible] = useState(false);
  const [recalculateModalPayload, setRecalculateModalPayload] = useState(null);
  const [includeCertificate, setIncludeCertificate] = useState(false);
  const [selectedCertificateIds, setSelectedCertificateIds] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const [loadingCertificates, setLoadingCertificates] = useState(false);

  const [reportForm] = Form.useForm();
  const materialsWeatherModalRef = useRef(null);

  const canOpenMaterialsWeatherDetails = Boolean(
    selectedSOW?.id && logDateRange?.fromDate && logDateRange?.toDate
  );

  // Function to fetch data based on date range
  const fetchWeldTestDetails = async (start, end) => {
    if (!selectedSOW) return;
    if (start && end) {
      var fromDate = moment(start).startOf('day').format('YYYY-MM-DD HH:mm:ss');
      var toDate = moment(end).endOf('day').format('YYYY-MM-DD HH:mm:ss');
      const obj = {
        startDate: fromDate,
        endDate: toDate,
        sowId: selectedSOW.id,
      };

      const list = await OnFetchWeldTestDetails(obj);
      console.log('Fetched Weld Test Data:', list);

      if (list && list.length > 0) {
        setWeldTestList(list);
      } else {
        setWeldTestList([]);
      }
    }
  };

  // Function to fetch heat profile report numbers
  const fetchHeatProfileList = async () => {
    if (!selectedProject?.id) return;

    setLoadingHeatProfiles(true);
    try {
      // Make actual API call to fetch heat profile list
      const response = await axiosConfig.get('/project-heat-profile/list-for-report', {
        params: { id: selectedProject.id },
      });

      // Extract data from response - API returns {message: "success", data: [...]}
      const heatProfileData = response.data?.data || [];

      setHeatProfileList(heatProfileData);
    } catch (error) {
      console.error('Error fetching heat profile list:', error);
      notification.error({
        message: 'Failed to fetch heat profile list',
        description: error?.response?.data?.message || 'Please try again later',
      });
      setHeatProfileList([]);
    } finally {
      setLoadingHeatProfiles(false);
    }
  };

  // Heat Profile handlers
  const showHeatProfileModal = () => {
    setIsHeatProfileModalVisible(true);
    setShowHeatProfileForm(false);
    setEditingHeatProfile(null);
  };

  const handleHeatProfileCancel = () => {
    setIsHeatProfileModalVisible(false);
    setShowHeatProfileForm(false);
    setEditingHeatProfile(null);
  };

  const handleCreateHeatProfile = () => {
    setShowHeatProfileForm(true);
    setEditingHeatProfile(null);
  };

  const handleEditHeatProfile = (record) => {
    setEditingHeatProfile(record);
    setShowHeatProfileForm(true);
  };

  const handleHeatProfileFormClose = () => {
    setShowHeatProfileForm(false);
    setEditingHeatProfile(null);
  };

  /** POST /pqt-weld/recalculate-overall-status — body `{ sowId, date }` (`axiosConfig1`). Returns whether the request succeeded. */
  const executeRecalculatePqtWeld = async (sowId, datePayload) => {
    setPqtWeldRecalculateLoading(true);
    try {
      await axiosConfig.post('/pqt-weld/recalculate-overall-status', {
        sowId,
        date: datePayload,
      });
      if (logDateRange?.fromDate && logDateRange?.toDate) {
        onAfterRecalculateSuccess?.();
      }
      notification.success({
        message: 'Recalculate requested',
        description:
          logDateRange?.fromDate && logDateRange?.toDate
            ? 'Overall status was recalculated; the inspection log table was refreshed for the current date range.'
            : 'Overall status is being recalculated for this SOW. Open a calendar range to refresh the log table.',
      });
      return true;
    } catch (error) {
      const desc =
        error?.message ||
        error?.response?.data?.message ||
        error?.error ||
        'Failed to recalculate. Please try again.';
      notification.error({
        message: 'Recalculate failed',
        description: typeof desc === 'string' ? desc : JSON.stringify(desc),
      });
      return false;
    } finally {
      setPqtWeldRecalculateLoading(false);
    }
  };

  const handleRecalculateModalCancel = () => {
    setIsRecalculateModalVisible(false);
    setRecalculateModalPayload(null);
  };

  const handleRecalculateModalProceed = async () => {
    if (!recalculateModalPayload) return;
    const { sowId, datePayload } = recalculateModalPayload;
    const ok = await executeRecalculatePqtWeld(sowId, datePayload);
    if (ok) {
      setIsRecalculateModalVisible(false);
      setRecalculateModalPayload(null);
    }
  };

  const fetchCertificateList = async () => {
    const projectId = selectedProject?.id ?? projectIdValue;
    if (projectId == null || projectId === '') return;

    setLoadingCertificates(true);
    try {
      const response = await axiosConfig.get('/project-material/by-project', {
        params: { projectId },
      });
      setCertificateList(parseProjectMaterialByProject(response));
    } catch (error) {
      console.error('project-material/by-project:', error);
      setCertificateList([]);
      notification.error({
        message: 'Failed to load certificates',
        description: error?.message || error?.error || 'Please try again later.',
      });
    } finally {
      setLoadingCertificates(false);
    }
  };

  const certificateOptions = certificateList.filter(hasMaterialCertificate);

  const handleRecalculatePqtWeld = () => {
    const sowId = selectedSOW?.id;
    if (sowId == null || sowId === '') {
      notification.warning({
        message: 'Select a pipeline',
        description: 'Choose a SOW (pipeline) before recalculating.',
      });
      return;
    }
    const dateRaw = logDateRange?.fromDate ?? startDate;
    if (!dateRaw) {
      notification.warning({
        message: 'Date required',
        description: 'Pick a calendar range or report date before recalculating.',
      });
      return;
    }
    const dateM = moment.utc(dateRaw, ['YYYY-MM-DD', moment.ISO_8601], true);
    if (!dateM.isValid()) {
      notification.warning({
        message: 'Invalid date',
        description: 'Use a valid date (YYYY-MM-DD).',
      });
      return;
    }
    const datePayload = dateM.format('YYYY-MM-DD');
    setRecalculateModalPayload({ sowId, datePayload });
    setIsRecalculateModalVisible(true);
  };

  const showModal = async () => {
    setIsReportModalVisible(true);
    // if (selectedSOW)
    //     setPipeline(selectedSOW.pipelineSection)

    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      var userName = user?.name || '';
      setName(userName);

      reportForm.setFieldsValue({ name: userName });
    }

    const start = moment().startOf('month').format('YYYY-MM-DD');
    const end = moment().endOf('month').format('YYYY-MM-DD');
    setStartDate(start);
    setEndDate(end);

    // Reset form state
    setReportGenerated(false);
    setGeneratedReportUrl(null);
    setIncludeHeatProfile(false);
    setSelectedHeatProfileIds([]);
    setIncludeCertificate(false);
    setSelectedCertificateIds([]);

    // Set default current month dates & fetch data
    fetchWeldTestDetails(start, end);

    // Fetch heat profile and certificate lists
    await fetchHeatProfileList();
    await fetchCertificateList();
  };

  const handleOk = () => {
    // // if (reportGenerated && generatedReportUrl) {
    //     // Handle sharing the report
    //     handleShareReport();
    // // } else {
    // Handle generating the report
    handleGenerateReport();
    // }
  };

  const handleGenerateReport = () => {
    console.log('Starting report generation...'); // Debug log
    console.log('Current form state:', {
      startDate,
      endDate,
      name,
      pipeline,
      includeHeatProfile,
      selectedHeatProfileIds,
      includeCertificate,
      selectedCertificateIds,
    }); // Debug log

    reportForm
      .validateFields()
      .then(async (data) => {
        console.log('Form validation data:', data); // Debug log

        // Get current form values
        const currentName = data.name || name;
        if (!data.email) {
          notification.warning({
            message: 'Provide Email to proceed!',
          });
          return;
        }
        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emails = data.email.split(',').map((email) => email.trim());
        const invalidEmails = emails.filter((email) => !emailRegex.test(email));

        if (invalidEmails.length > 0) {
          notification.error({
            message: 'Invalid email format',
            description: `Please check: ${invalidEmails.join(', ')}`,
          });
          return;
        }

        if (!startDate) {
          notification.warning({
            message: 'Select From Date to proceed!',
          });
          return;
        }
        if (!endDate) {
          notification.warning({
            message: 'Select To Date to proceed!',
          });
          return;
        }
        if (!currentName) {
          notification.warning({
            message: 'Provide Name to proceed!',
          });
          return;
        }
        if (pipeline.length == 0) {
          notification.warning({
            message: 'Select Welds to proceed!',
          });
          return;
        }
        if (includeHeatProfile && selectedHeatProfileIds.length == 0) {
          notification.warning({
            message: 'Select Heat Profile Report Numbers to proceed!',
          });
          return;
        }
        if (includeCertificate && selectedCertificateIds.length === 0) {
          notification.warning({
            message: 'Select Certificates to proceed!',
          });
          return;
        }

        console.log('All validations passed, proceeding with report generation...'); // Debug log

        // Proceed with report generation
        var sowId = selectedSOW.id;

        let allWelds = pipeline.includes('All')
          ? weldTestList.map((item) => String(item.weldId)) // Ensure IDs are strings
          : pipeline.filter((value) => value !== 'All').map(String); // Convert to string
        var fromDate = moment(startDate).startOf('day').toISOString(); // 00:00:00.000Z
        var toDate = moment(endDate).endOf('day').toISOString(); // 23:59:59.999Z
        console.log('selected weld IDs', allWelds);

        var obj = {
          fromDate: fromDate,
          toDate: toDate,
          sowId: sowId,
          format: 'PDF',
          weldIds: allWelds,
          generatedBy: currentName,
          projectId: selectedProject.id,
          generateReport: true,
          heatProfiles: includeHeatProfile ? selectedHeatProfileIds : [],
          materialCertificateUrls: includeCertificate
            ? getSelectedMaterialCertificateUrls(certificateList, selectedCertificateIds)
            : [],
          emailToDestinations: data.email,
        };

        console.log('Report request object:', obj); // Debug log

        if (fromDate > toDate) {
          notification.warn({
            message: 'From date should be previous than To date',
          });
        } else {
          setLoadingReport(true);
          console.log('Calling OnGeneratePQtReports...'); // Debug log
          const reportUrl = await OnGeneratePQtReports(obj);
          console.log('Report URL received:', reportUrl); // Debug log

          if (reportUrl) {
            setGeneratedReportUrl(reportUrl);
            setReportGenerated(true);

            let fileName = reportUrl.split('/').pop(); // Gets the last part of the URL
            fileName = decodeURIComponent(fileName); // Decodes any encoded characters

            // Open in new tab instead of downloading
            window.open(reportUrl, '_blank');
            // notification.success({
            //     message: 'Report is being generated and will be sent via email when ready.'
            // });
          } else {
            console.log('Failed to generate report. Please try again.');
            // notification.error({
            //     message: 'Failed to generate report. Please try again.'
            // });
          }
          setLoadingReport(false);
        }
      })
      .catch((error) => {
        console.error('Form validation failed:', error); // Debug log
        setLoadingReport(false);
      });
  };

  const handleShareReport = () => {
    reportForm.validateFields(['email']).then(async (data) => {
      if (!data.email) {
        notification.warning({
          message: 'Provide Email to proceed!',
        });
        return;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emails = data.email.split(',').map((email) => email.trim());
      const invalidEmails = emails.filter((email) => !emailRegex.test(email));

      if (invalidEmails.length > 0) {
        notification.error({
          message: 'Invalid email format',
          description: `Please check: ${invalidEmails.join(', ')}`,
        });
        return;
      }

      // Show loading for 1 second
      setLoadingReport(true);

      // Call the same API with emailToDestinations
      const obj = {
        fromDate: moment(startDate).startOf('day').toISOString(),
        toDate: moment(endDate).endOf('day').toISOString(),
        sowId: selectedSOW.id,
        format: 'PDF',
        weldIds: pipeline.includes('All')
          ? weldTestList.map((item) => String(item.weldId))
          : pipeline.filter((value) => value !== 'All').map(String),
        generatedBy: name,
        projectId: selectedProject.id,
        generateReport: true,
        heatProfiles: includeHeatProfile ? selectedHeatProfileIds : [],
        materialCertificateUrls: includeCertificate
          ? getSelectedMaterialCertificateUrls(certificateList, selectedCertificateIds)
          : [],
        emailToDestinations: data.email,
      };

      // Fire and forget - don't wait for response
      OnGeneratePQtReports(obj).catch((error) => {
        console.error('Error sending report via email:', error);
      });

      // Fake loading for 1 second then close
      setTimeout(() => {
        setLoadingReport(false);
        notification.success({
          message: 'Report sent successfully!',
        });

        // Reset form and close modal
        reportForm.resetFields();
        setIsReportModalVisible(false);
        setStartDate(null);
        setEndDate(null);
        setPipeline([]);
        setEmail('');
        setName('');
        setReportGenerated(false);
        setGeneratedReportUrl(null);
        setIncludeHeatProfile(false);
        setSelectedHeatProfileIds([]);
        setIncludeCertificate(false);
        setSelectedCertificateIds([]);
      }, 1000);
    });
  };

  useEffect(() => {
    if (!isLogReportsLoading) {
      setLoadingReport(false);
      setIsReportModalVisible(false);
      setStartDate(null);
      setEndDate(null);
      setPipeline([]);
      setEmail('');
      setName('');
      setLoadingReport(false);
    }
  }, [isLogReportsLoading]);

  const handleCancel = () => {
    reportForm.resetFields(); //resetting input fields
    setIsReportModalVisible(false);
    setStartDate(null);
    setEndDate(null);
    setPipeline([]);
    setEmail('');
    setName('');
    setLoadingReport(false);
    // Reset heat profile and certificate state
    setIncludeHeatProfile(false);
    setSelectedHeatProfileIds([]);
    setIncludeCertificate(false);
    setSelectedCertificateIds([]);
  };

  // const onKeyDown = (event) =>{
  //     console.log(event)
  //     if(event.which === 13 || event.which === 188 || event.which === 186) {
  //         console.log("done job", email)
  //     }
  // }

  // **Handle Start Date Change**
  const handleStartDateChange = async (date, dateString) => {
    setLoadingWeldIds(true);
    dateString =
      dateString && moment(dateString).isValid() ? moment(dateString).format('YYYY-MM-DD') : '';
    if (endDate && dateString > endDate) {
      notification.warn({ message: 'From date should be before To date' });
      return;
    }
    setStartDate(dateString);
    await fetchWeldTestDetails(dateString, endDate);
    setLoadingWeldIds(false);
  };

  // **Handle End Date Change**
  const handleEndDateChange = async (date, dateString) => {
    setLoadingWeldIds(true);
    dateString =
      dateString && moment(dateString).isValid() ? moment(dateString).format('YYYY-MM-DD') : '';
    setEndDate(dateString);
    await fetchWeldTestDetails(startDate, dateString);
    setLoadingWeldIds(false);
  };
  // const [subCategoryList, setSubCategoryList] = useState([]);
  // const processSubCategories = (data) => {
  //     const weldIds = [...new Set(data.map(item => item.weldId))]; // Extract unique weldIds

  //     // Ensure 'All' is the first option
  //     if (!weldIds.includes("All")) {
  //         weldIds.unshift("All");
  //     }

  //     return weldIds.map(weldId => ({ subCategory: weldId })); // Convert to objects
  // };

  // useEffect(() => {
  //     const result = processSubCategories(weldTestList);
  //     setSubCategoryList(result);
  // }, [weldTestList]);

  // const handleSelectChange = (values) => {
  //     console.log("Selected values:", values);

  //     // Extract all weld IDs

  //     if (values.includes("All")) {
  //         if (!pipeline.includes('All')) {
  //             const allWelds = weldTestList.map(item => item.weldId);

  //             const ids = values.filter(value => value !== "All")
  //             if (ids && ids.length > 0) {
  //                 setPipeline(ids);
  //             }
  //             else // If "All" is selected, select all weld IDs
  //                 setPipeline(values);
  //         }
  //         else {
  //             setPipeline(['All']);
  //         }

  //     }

  //     else if (values.length === 0) {
  //         // If everything is deselected, clear selection
  //         setPipeline([]);
  //     } else {
  //         // If specific items are selected, remove "All" and keep the selected ones
  //         setPipeline(values.filter(value => value !== "All"));
  //     }
  // };

  const handleSelectChange = (values) => {
    //console.log("Selected values:", values);

    // If "All" is selected, keep only "All"
    if (!pipeline.includes('All') && values.includes('All')) {
      setPipeline(['All']);
    }
    // If other items are selected, remove "All"
    else {
      setPipeline(values.filter((value) => value !== 'All'));
    }
  };

  return (
    <>
      <div className="pqt-generate-report-toolbar">
        <CrceButton
          label="Generate Report"
          variant="secondary"
          size="medium"
          icon={FileBarChart}
          onClick={showModal}
        />
        <CrceButton
          label="Manage Heat Profile"
          variant="tertiary"
          size="medium"
          icon={Thermometer}
          onClick={showHeatProfileModal}
        />
        <CrceButton
          label="View Details"
          variant="tertiary"
          size="medium"
          icon={Eye}
          disabled={!canOpenMaterialsWeatherDetails}
          onClick={() => materialsWeatherModalRef.current?.openViewDetails?.()}
          aria-label="View environmental conditions, materials, and inspection equipment"
        />
        <MaterialsWeatherInspectionModal
          ref={materialsWeatherModalRef}
          hideTrigger
          selectedSOW={selectedSOW}
          logDateRange={logDateRange}
          onViewDetails={onViewDetails}
        />
        <CrceButton
          label="Recalculate Results"
          variant="secondary"
          size="medium"
          onClick={handleRecalculatePqtWeld}
        />
      </div>
      <Modal
        width="min(92vw, 760px)"
        className="modern-create-project-modal modern-dsr-dt-add-modal modern-generate-report-modal"
        wrapClassName="modern-dsr-dt-add-modal__wrap"
        title={<h3 className="modern-dsr-dt-add-modal__h-title">Recalculate weld status</h3>}
        closeIcon={
          <span className="modern-dsr-dt-add-modal__close-icon" aria-hidden>
            <X size={20} strokeWidth={2} />
          </span>
        }
        centered
        visible={isRecalculateModalVisible}
        maskStyle={{ background: 'rgba(0, 0, 0, 0.5)' }}
        bodyStyle={{ maxHeight: 'min(85vh, 900px)', overflowY: 'auto' }}
        footer={[
          <CrceButton 
            key="cancel" 
            label="Cancel" 
            variant="tertiary" 
            size="medium" 
            onClick={handleRecalculateModalCancel} 
          />,
          <CrceButton
            key="proceed"
            label={pqtWeldRecalculateLoading ? "Proceeding..." : "Proceed"}
            variant="primary"
            size="medium"
            onClick={handleRecalculateModalProceed}
            disabled={pqtWeldRecalculateLoading ? true : undefined}
          />,
        ]}
      >
        <div style={{ color: '#374151', fontSize: '15px', lineHeight: 1.6 }}>
          <p style={{ marginBottom: '10px' }}>
            Recalculate test results for all welds completed on{' '}
            <b style={{ color: '#EF314C' }}>
              {recalculateModalPayload &&
                moment
                  .utc(recalculateModalPayload.datePayload, 'YYYY-MM-DD')
                  .format('D-MMMM-YYYY')}
            </b>
            .
          </p>
          <p style={{ marginBottom: 0 }}>Are you sure you want to proceed?</p>
        </div>
      </Modal>
      <div>
        <Modal
          width="min(92vw, 960px)"
          className="modern-create-project-modal modern-dsr-dt-add-modal modern-generate-report-modal pqt-generate-report-modal"
          wrapClassName="modern-dsr-dt-add-modal__wrap"
          title={<h3 className="modern-dsr-dt-add-modal__h-title">Generate Report</h3>}
          closeIcon={
            <span className="modern-dsr-dt-add-modal__close-icon" aria-hidden>
              <X size={20} strokeWidth={2} />
            </span>
          }
          centered
          visible={isReportModalVisible}
          onOk={handleOk}
          onCancel={handleCancel}
          maskStyle={{ background: 'rgba(0, 0, 0, 0.5)' }}
          bodyStyle={{ maxHeight: 'min(85vh, 900px)', overflowY: 'auto' }}
          footer={[
            <CrceButton key="cancel" label="Close" variant="tertiary" size="medium" onClick={handleCancel} />,
            <CrceButton
              key="apply"
              label={reportGenerated ? 'Share' : 'Generate Report'}
              variant="primary"
              size="medium"
              onClick={handleOk}
              disabled={loadingReport ? true : undefined}
            />,
          ]}
        >
          <div className="modern-dsr-tech-log-section modern-dsr-dt-add-modal__form-scope">
            <Form
              form={reportForm}
              name="basic"
              layout="vertical"
              className="modern-dsr-dt-add-modal__form pqt-generate-report-form"
            >
            <Row gutter={24}>
              <Col lg={12}>
                <Form.Item
                  className="date-picker"
                  label="From"
                  name="startDate"
                  required
                  // initialValue={moment(startDate, "YYYY-MM-DD")}
                >
                  <div>
                    <DatePicker
                      placholder="From"
                      format="DD-MMM-YYYY"
                      dropdownClassName={`${DATE_DROPDOWN} pqt-generate-report-date-dd`}
                      getPopupContainer={getPopupContainerBody}
                      className="w-100"
                      value={startDate ? moment(startDate) : null}
                      onChange={(date, dateString) => handleStartDateChange(date, dateString)}
                    />
                  </div>
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  className="date-picker"
                  label="To"
                  name="endDate"
                  required
                  // initialValue={moment(endDate, "YYYY-MM-DD")}
                >
                  <div>
                    <DatePicker
                      format="DD-MMM-YYYY"
                      dropdownClassName={`${DATE_DROPDOWN} pqt-generate-report-date-dd`}
                      getPopupContainer={getPopupContainerBody}
                      className="w-100"
                      value={endDate ? moment(endDate) : null}
                      onChange={(date, dateString) => handleEndDateChange(date, dateString)}
                      disabledDate={(current) => startDate && current < moment(startDate)}
                    />
                  </div>
                </Form.Item>
              </Col>

              <Col lg={12}>
                <Form.Item className="pqt-generate-report-welds-item" label="Welds" name="" required>
                  <div>
                    <Select
                      className="client-select multi-select"
                      placeholder="Select Weld"
                      dropdownClassName={`${SELECT_DROPDOWN} pqt-generate-report-select-dd`}
                      getPopupContainer={getPopupContainerBody}
                      loading={loadingWeldIds}
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      mode="multiple" // Enable multiple selection
                      onChange={handleSelectChange}
                      value={pipeline}

                      // filterOption={(input, option) =>
                      //     option.children.toLowerCase().includes(input.toLowerCase())
                      // }
                      // dropdownRender={menu => (
                      //     <>
                      //         {menu}
                      //         <Divider style={{ margin: '8px 0', borderTop: '1px solid lightgrey' }} />
                      //         <Space align="center" style={{ padding: '0 8px 4px' }}>
                      //             <Input placeholder="Add Sub category" value={subCategory} onChange={(e) => setSubCategory(e.target.value)} />
                      //             <Typography.Link onClick={addSubcategoryItem} style={{ whiteSpace: 'nowrap', color: "green" }}>
                      //                 <CheckOutlined />
                      //             </Typography.Link>
                      //         </Space>
                      //     </>
                      // )}
                    >
                      {/* {subCategoryList.map((item, i) => (
                                            <Option key={i} value={item.subCategory}>{item.subCategory}</Option>
                                        ))} */}

                      {weldTestList.length > 0 && (
                        <Option key="all" value="All">
                          All
                        </Option>
                      )}
                      {weldTestList.map((item) => (
                        <Option key={item.weldId} value={item.weldId}>
                          {item.weldId}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </Form.Item>
              </Col>

              <Col lg={12}>
                <Form.Item label="Generated By" name="name" required>
                  <div>
                    <Input
                      // disabled
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      size="large"
                      placeholder="Name or Email"
                    />
                  </div>
                </Form.Item>
              </Col>
              <Col lg={24} style={{}}>
                <Form.Item>
                  <CrceCheckbox
                    label="Include Heat Profile"
                    checked={includeHeatProfile}
                    onChange={(checkedOrEvent) =>
                      setIncludeHeatProfile(
                        typeof checkedOrEvent === 'boolean'
                          ? checkedOrEvent
                          : (checkedOrEvent?.target?.checked ?? false)
                      )
                    }
                    borderColor="#00C9A7"
                  />
                </Form.Item>
              </Col>
              {includeHeatProfile && (
                <Col lg={24} style={{ marginBottom: '24px' }}>
                  <Form.Item
                    label={<span style={{ fontWeight: '500' }}>Heat Profile Report Numbers</span>}
                    name="heatProfileNumbers"
                    required={includeHeatProfile}
                  >
                    <Select
                      className="heat-profile-select client-select"
                      mode="multiple"
                      placeholder="Select Heat Profile Report Numbers"
                      dropdownClassName={`${SELECT_DROPDOWN} pqt-generate-report-select-dd`}
                      getPopupContainer={getPopupContainerBody}
                      value={selectedHeatProfileIds}
                      onChange={(value) => setSelectedHeatProfileIds(value)}
                      showSearch
                      optionFilterProp="children"
                      loading={loadingHeatProfiles}
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {heatProfileList &&
                        heatProfileList.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.reportNumber}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              <Col lg={24} style={{}}>
                <Form.Item>
                  <CrceCheckbox
                    label="Include Certificate"
                    checked={includeCertificate}
                    onChange={(checkedOrEvent) =>
                      setIncludeCertificate(
                        typeof checkedOrEvent === 'boolean'
                          ? checkedOrEvent
                          : (checkedOrEvent?.target?.checked ?? false)
                      )
                    }
                    borderColor="#00C9A7"
                  />
                </Form.Item>
              </Col>
              {includeCertificate && (
                <Col lg={24} style={{ marginBottom: '24px' }}>
                  <Form.Item
                    label={<span style={{ fontWeight: '500' }}>Certificates</span>}
                    name="certificateIds"
                    required={includeCertificate}
                  >
                    <Select
                      className="heat-profile-select client-select"
                      mode="multiple"
                      placeholder="Select Certificates"
                      dropdownClassName={`${SELECT_DROPDOWN} pqt-generate-report-select-dd`}
                      getPopupContainer={getPopupContainerBody}
                      value={selectedCertificateIds}
                      onChange={(value) => setSelectedCertificateIds(value)}
                      showSearch
                      optionFilterProp="children"
                      loading={loadingCertificates}
                      notFoundContent={
                        loadingCertificates ? 'Loading certificates...' : 'No certificates available'
                      }
                      filterOption={(input, option) =>
                        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {certificateOptions.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {formatCertificateOptionLabel(item)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              <Col lg={24} style={{ marginBottom: '24px' }}>
                <Form.Item
                  label={<span style={{ fontWeight: '500' }}>Email</span>}
                  name="email"
                  required
                  style={{ marginBottom: 0 }}
                >
                  <Input
                    // disabled
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="large"
                    placeholder="Enter emails followed by comma (,)"
                    // onKeyDown={onKeyDown}
                  />
                </Form.Item>
                <span style={{ fontSize: '12px', position: 'relative', left: '10px' }}>
                  eg: 1234@mail.com, 234@email.com
                </span>
              </Col>
            </Row>
            </Form>
          </div>
        </Modal>
      </div>

      {/* Heat Profile Management Modal */}
      <Modal
        width="98vw"
        className="heat-profile-modal"
        title=""
        visible={isHeatProfileModalVisible}
        onCancel={handleHeatProfileCancel}
        footer={null}
        destroyOnClose={true}
        bodyStyle={{ padding: 0, background: '#f1f5f9' }}
        style={{ top: 10 }}
      >
        {showHeatProfileForm ? (
          <div style={{ padding: '20px', background: 'white' }}>
            <ProjectHeatProfile
              selectedProject={selectedProject}
              selectedSOW={selectedSOW}
              editingRecord={editingHeatProfile}
              onClose={handleHeatProfileFormClose}
            />
          </div>
        ) : (
          <ProjectHeatProfileList
            selectedProject={selectedProject}
            selectedSOW={selectedSOW}
            setIsHeatProfileModalVisible={setIsHeatProfileModalVisible}
            onEdit={handleEditHeatProfile}
            onCreateNew={handleCreateHeatProfile}
          />
        )}
      </Modal>
    </>
  );
};

export default GenerateReport;
